import { userAtom } from "@framework/config/atoms";

export function useIsLoggedIn() {
  const user = userAtom.useValue();

  return (user.userType || user.type) === "user";
}

export function useIsGuest() {
  const user = userAtom.useValue();

  return (user.userType || user.type) === "guest";
}
